/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetDatabaseEntryMediaRequest {
    databaseIdOrSlug: string;
    entryId: string;
    fieldId: string;
    resource: string;
}

export interface GetDatabaseMediaRequest {
    databaseIdOrSlug: string;
    resource: string;
}

/**
 * 
 */
export class DatabasePublicMediaControllerApi extends runtime.BaseAPI {

    /**
     * get database entry media data by id or slug
     * get database entry media data by id or slug
     */
    async getDatabaseEntryMediaRaw(requestParameters: GetDatabaseEntryMediaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.databaseIdOrSlug === null || requestParameters.databaseIdOrSlug === undefined) {
            throw new runtime.RequiredError('databaseIdOrSlug','Required parameter requestParameters.databaseIdOrSlug was null or undefined when calling getDatabaseEntryMedia.');
        }

        if (requestParameters.entryId === null || requestParameters.entryId === undefined) {
            throw new runtime.RequiredError('entryId','Required parameter requestParameters.entryId was null or undefined when calling getDatabaseEntryMedia.');
        }

        if (requestParameters.fieldId === null || requestParameters.fieldId === undefined) {
            throw new runtime.RequiredError('fieldId','Required parameter requestParameters.fieldId was null or undefined when calling getDatabaseEntryMedia.');
        }

        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('resource','Required parameter requestParameters.resource was null or undefined when calling getDatabaseEntryMedia.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/db-media/{databaseIdOrSlug}/{entryId}/{fieldId}/{resource}`.replace(`{${"databaseIdOrSlug"}}`, encodeURIComponent(String(requestParameters.databaseIdOrSlug))).replace(`{${"entryId"}}`, encodeURIComponent(String(requestParameters.entryId))).replace(`{${"fieldId"}}`, encodeURIComponent(String(requestParameters.fieldId))).replace(`{${"resource"}}`, encodeURIComponent(String(requestParameters.resource))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database entry media data by id or slug
     * get database entry media data by id or slug
     */
    async getDatabaseEntryMedia(requestParameters: GetDatabaseEntryMediaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseEntryMediaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get database media data by id or slug
     * get database media data by id or slug
     */
    async getDatabaseMediaRaw(requestParameters: GetDatabaseMediaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.databaseIdOrSlug === null || requestParameters.databaseIdOrSlug === undefined) {
            throw new runtime.RequiredError('databaseIdOrSlug','Required parameter requestParameters.databaseIdOrSlug was null or undefined when calling getDatabaseMedia.');
        }

        if (requestParameters.resource === null || requestParameters.resource === undefined) {
            throw new runtime.RequiredError('resource','Required parameter requestParameters.resource was null or undefined when calling getDatabaseMedia.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/db-media/{databaseIdOrSlug}/{resource}`.replace(`{${"databaseIdOrSlug"}}`, encodeURIComponent(String(requestParameters.databaseIdOrSlug))).replace(`{${"resource"}}`, encodeURIComponent(String(requestParameters.resource))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get database media data by id or slug
     * get database media data by id or slug
     */
    async getDatabaseMedia(requestParameters: GetDatabaseMediaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDatabaseMediaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
